import { useState, useEffect } from 'react'
import fetch from 'lib/fetch'
import Cookies from 'js-cookie'
import { apiV3BLLaunchDarklyFlagPath } from 'lib/urls'
import { isPrerenderUserAgent } from 'lib/isPrerenderUserAgent'
import useCurrentUser from '../useCurrentUser/useCurrentUser'

// This hook will use the babylist API as a proxy and will not use the LD client
const useFeatureFlag = (flagName: string, defaultValue: boolean | string) => {
  const [flagValue, setFlagValue] = useState(defaultValue)
  const [currentUser] = useCurrentUser()
  const blLdFlags = Cookies.get('bl_ld_flags')

  let flagsFromCurrentUser = {}
  if (currentUser?.ldFlagsJson) {
    try {
      flagsFromCurrentUser = JSON.parse(currentUser.ldFlagsJson)
    } catch (e) {
      console.error('Error parsing currentUser.ldFlagsJson' + e)
    }
  }

  const flagsFromCookie = blLdFlags ? JSON.parse(blLdFlags) : {}
  const ldFlags: { [k: string]: boolean | string } = {
    ...flagsFromCookie,
    ...flagsFromCurrentUser,
  }

  useEffect(() => {
    if (typeof window === 'undefined' || isPrerenderUserAgent()) {
      setFlagValue(defaultValue)
      return
    }

    const value = ldFlags.hasOwnProperty(flagName)
      ? ldFlags[flagName]
      : defaultValue

    setFlagValue(value)
  }, [flagName, defaultValue, currentUser])

  useEffect(() => {
    if (
      typeof window === 'undefined' ||
      isPrerenderUserAgent() ||
      !ldFlags.hasOwnProperty(flagName) ||
      (!currentUser && !blLdFlags)
    ) {
      return
    }

    // Calling the proxy API to register the flag usage
    // We don't need to wait for the response
    const path = `${apiV3BLLaunchDarklyFlagPath}?flag_name=${flagName}`
    fetch(path, { method: 'GET' })
  }, [flagName, currentUser])

  return flagValue
}

export default useFeatureFlag
